import startCase from 'lodash/startCase'
import { BsBadge3D } from 'react-icons/bs'
import { FiGlobe } from 'react-icons/fi'
import { LiaRoadSolid } from 'react-icons/lia'
import { MapRef } from 'react-map-gl/mapbox'

import { MapStyle, useMapContext } from './MapContext'

interface MapStyleToggleProps {
  mapRef: React.RefObject<MapRef | null>
  onChangeStyle: () => void
}

const styles = {
  road: { pitch: 0, bearing: 0, icon: <LiaRoadSolid className="w-4 h-4" /> },
  satellite: { pitch: 0, bearing: 0, icon: <FiGlobe className="w-4 h-4" /> },
  '3d': { pitch: 40, bearing: 0, icon: <BsBadge3D className="w-4 h-4" /> },
}
export const MapStyleToggles = ({ mapRef, onChangeStyle }: MapStyleToggleProps) => {
  const context = useMapContext()

  return (
    <div className="absolute top-28 md:top-4 right-4 z-10 bg-base-100 rounded-lg shadow-lg p-1 flex flex-col gap-1">
      {Object.entries(styles).map(([style, styleProps]) => (
        <button
          key={style}
          onClick={() => {
            if (style === context.mapState.style) {
              return
            }
            onChangeStyle()
            if (mapRef.current?.getMap) {
              const map = mapRef.current.getMap()
              map.setPitch(styleProps.pitch)
              map.setBearing(styleProps.bearing)
              context.setMapState({
                ...context.mapState,
                style: style as MapStyle,
                pitch: styleProps.pitch,
                bearing: styleProps.bearing,
              })
            } else {
              context.setMapState({ ...context.mapState, style: style as MapStyle })
            }
          }}
          className={`tooltip tooltip-left tooltip-primary btn btn-sm btn-square ${context.mapState.style === style ? 'btn-primary' : 'btn-ghost'}`}
          data-tip={style === '3d' ? '3D' : startCase(style)}
        >
          {styleProps.icon}
        </button>
      ))}
    </div>
  )
}
